exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/dboxMap/dboxMap.component.scss
// module id = ../../../../../src/app/dboxMap/dboxMap.component.scss
// module chunks = main